export default __webpack_public_path__ + "static/media/Eng_ComparePricing_Homepage.fbae4bc6.webp";